module.exports = __webpack_public_path__ + "img/didichuxing.a148e2ea.png";